module.exports = __webpack_public_path__ + "img/CanCFLogo - Lite.f534b968.png";